import { Injectable } from '@angular/core';
import { CrudService } from '../../shared/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BeaconService extends CrudService {

  merchantId;
  constructor(protected http: HttpClient) {
    super(http);
    this.setObject('beacon');
  }

  all(): Observable<any> {
    return this.http.get(this.apiUrl + this.object+'/list/' + this.merchantId);
  }
}